import { Exhibit, ExhibitStatus } from '../../../types/models';

interface ExhibitInfoProps {
    exhibit: Exhibit;
    className?: string;
    languageCode?: string;
}

export const ExhibitInfo = ({ exhibit, className, languageCode = 'en' }: ExhibitInfoProps) => {
    // Find the translation in the requested language or fall back to the first one
    const translation = exhibit.translations.find((t) => t.language_code === languageCode) || exhibit.translations[0];

    return (
        <div className={`rounded-lg bg-white p-6 shadow-sm ${className}`}>
            {/* Header with status badge */}
            <div className="mb-4 flex items-start justify-between">
                <h1 className="text-2xl font-semibold">{translation?.title || 'Untitled Exhibit'}</h1>

                {/* {exhibit.status !== ExhibitStatus.Published && (
                    <span
                        className={`rounded-full px-3 py-1 text-sm font-medium ${
                            exhibit.status === ExhibitStatus.Draft ? 'bg-yellow-100 text-yellow-800' : 'bg-gray-100 text-gray-800'
                        }`}
                    >
                        {exhibit.status}
                    </span>
                )} */}
            </div>

            {/* Metadata grid */}
            <div className="mb-6 grid grid-cols-1 gap-x-6 gap-y-3 sm:grid-cols-2 lg:grid-cols-3">
                {/* Artist */}
                <div className="flex flex-col">
                    <span className="text-sm text-gray-500">Artist</span>
                    <span className="font-medium">{exhibit.artist || 'Unknown'}</span>
                </div>

                {/* Year Created */}
                <div className="flex flex-col">
                    <span className="text-sm text-gray-500">Year Created</span>
                    <span className="font-medium">{exhibit.year_created || 'Unknown'}</span>
                </div>

                {/* Medium */}
                <div className="flex flex-col">
                    <span className="text-sm text-gray-500">Medium</span>
                    <span className="font-medium">{translation?.medium || 'Not specified'}</span>
                </div>

                {/* Dimensions */}
                <div className="flex flex-col">
                    <span className="text-sm text-gray-500">Dimensions</span>
                    <span className="font-medium">{exhibit.dimensions || 'Not specified'}</span>
                </div>

                {/* Acquisition Date */}
                <div className="flex flex-col">
                    <span className="text-sm text-gray-500">Acquisition Date</span>
                    <span className="font-medium">
                        {exhibit.acquisition_date ? new Date(exhibit.acquisition_date).toLocaleDateString() : 'Not specified'}
                    </span>
                </div>

                {/* Rooms - Only show if there are rooms */}
                {exhibit.rooms && exhibit.rooms.length > 0 && (
                    <div className="flex flex-col">
                        <span className="text-sm text-gray-500">On Display</span>
                        <span className="font-medium">
                            {exhibit.rooms
                                .map((room) => {
                                    const roomName =
                                        room.translations.find((t) => t.language_code === languageCode)?.name || room.translations[0]?.name;
                                    return roomName;
                                })
                                .filter(Boolean)
                                .join(', ')}
                        </span>
                    </div>
                )}
            </div>

            {/* Description */}
            {translation?.description && (
                <div className="mb-6">
                    <h2 className="mb-2 text-lg font-medium">Description</h2>
                    <div className="prose max-w-none text-gray-700">{translation.description}</div>
                </div>
            )}
        </div>
    );
};
